import {FC} from 'react';
import Link from 'next/link';
import {PromoCard} from '@components/PromoCard';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import {getLocalizedRoute, routes} from '@utils/routes';
import {useLocale} from '@utils/locale';
import {Currency} from '.cache/__types__';

export const PremiumPromoCard: FC<{priceSaved: number; currency: Currency}> = ({priceSaved, currency}) => {
    const locale = useLocale();

    return (
        <PromoCard iconName="Star" variant="green">
            <PromoCard.Title>
                <FormattedMessage defaultMessage="Máte o nabídku zájem?" />
            </PromoCard.Title>

            <PromoCard.Desc>
                <FormattedMessage
                    defaultMessage="Ušetřete {amount} na provizi a komunikujte se všemi majiteli."
                    values={{
                        amount: <FormattedNumber value={priceSaved} style="currency" currency={currency} maximumFractionDigits={0} />,
                    }}
                />
            </PromoCard.Desc>

            <PromoCard.Link>
                <Link href={getLocalizedRoute(routes.serviceCentrePremium, locale)} passHref>
                    <a>
                        <FormattedMessage defaultMessage="Chci Premium profil za 299\u00a0Kč." />
                    </a>
                </Link>
            </PromoCard.Link>
        </PromoCard>
    );
};
